// trabajadoresDemo.js — «− N trabajadores +» del calendario del simulador de CITAS (David, 30/10/2026:
// «si me dicen que son 2 … darle al − y que se quede en 2»). Espejo de lo de autoescuelas
// (profesoresStore.setNumeroProfesoresDemo). PURO.
//
// Quitar = el ÚLTIMO de la lista; sus citas de ejemplo dejan de verse (axiosClient filtra las citas de
// trabajadores que ya no están) y vuelven si se le vuelve a poner. Poner = primero los de ejemplo del
// sector que aún no estén y luego «Trabajador 4»…, con el horario de siempre del simulador.
"use strict";

export const MIN_TRABAJADORES = 1;
export const MAX_TRABAJADORES = 15;

export const idDeTrabajador = (w) => (w && (w.worker_id || w.user_id || w.id)) || null;

export function trabajadorExtra(n) {
  const id = `sim-extra-w${n}`;
  return { id, worker_id: id, user_id: id, name: `Trabajador ${n}`, active: true };
}

/** La lista de trabajadores con `n` (entre MIN y MAX). `pool` = los de ejemplo del sector, en orden. */
export function trabajadoresParaNumero(actuales = [], pool = [], n) {
  const objetivo = Math.max(MIN_TRABAJADORES, Math.min(MAX_TRABAJADORES, Math.round(Number(n) || 0)));
  const lista = [...actuales];
  if (lista.length >= objetivo) return lista.slice(0, objetivo);
  const usados = new Set(lista.map(idDeTrabajador));
  for (const w of pool) {
    if (lista.length >= objetivo) break;
    if (!usados.has(idDeTrabajador(w))) { lista.push(w); usados.add(idDeTrabajador(w)); }
  }
  for (let i = lista.length + 1; lista.length < objetivo; i++) {
    const w = trabajadorExtra(i);
    if (!usados.has(w.worker_id)) { lista.push(w); usados.add(w.worker_id); }
  }
  return lista;
}

/** Citas que se ven: las de trabajadores que siguen en la lista (y las que no llevan trabajador). */
export function citasVisibles(citas = [], trabajadores = []) {
  const ids = new Set(trabajadores.map(idDeTrabajador));
  return citas.filter((c) => !c || !c.worker_id || ids.has(c.worker_id));
}
